import React from "react";
import { Button } from "antd";
import NeurapulseLogo from "../../assets/images/neurapulse/neurapulse-logo-icon-blue.png";

interface INeurapulseButtonProps {
	loading?: boolean;
	disabled?: boolean;
	onClick: () => void;
}

const NeurapulseButton: React.FC<INeurapulseButtonProps> = ({
	onClick,
	loading,
	disabled,
}) => {
	return (
		<Button
			className="mr-auto btn-primary"
			onClick={onClick}
			loading={loading}
			disabled={disabled}
		>
			<img
				src={NeurapulseLogo}
				alt="Neurapulse Logo"
				width={16}
				style={{ marginRight: 8 }}
			/>
			Neurapulse
		</Button>
	);
};

export default NeurapulseButton;
